<template lang="pug">
.individual-match-ranking
  .sub-page-padding
    .container
      h1 個人戦ランキング
      p match.id: {{ matchId }}
</template>

<script>
export default {
  name: 'individualMatchRanking',
  computed: {
    matchId() {
      return this.$route.params.id
    },
  },
}
</script>
